import { BudgetRequestStateTypes, BudgetRequestActionTypes } from "./BudgetRequest.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: BudgetRequestStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const BudgetRequestReducer = (
  state: BudgetRequestStateTypes = INITIAL_STATE,
  action: any
): BudgetRequestStateTypes => {
  switch (action.type) {
    case BudgetRequestActionTypes.FETCH_ALL_BUDGET_REQUEST:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case BudgetRequestActionTypes.FETCH_ALL_BUDGET_REQUEST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case BudgetRequestActionTypes.FETCH_ALL_BUDGET_REQUEST_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case BudgetRequestActionTypes.FETCH_ALL_BUDGET_REQUEST_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case BudgetRequestActionTypes.FETCH_ONE_BUDGET_REQUEST:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case BudgetRequestActionTypes.FETCH_ONE_BUDGET_REQUEST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case BudgetRequestActionTypes.FETCH_ONE_BUDGET_REQUEST_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case BudgetRequestActionTypes.FETCH_ONE_BUDGET_REQUEST_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default BudgetRequestReducer;
